import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import { getExpectedResult } from '../../../redux/actions/subProjectProposal'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import SubProjectExpectedResultWidget from '../../../widgets/projectProposal/expectedresult/SubProjectExpectedResultWidget'

export default function SubProjectExpectedResult(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //const _schema = mockSchema //await getProjectName(proposalId)
      let _schema = await getExpectedResult(subProjectId)

      setSchema(_schema)
      setIsEditWidget({
        partner: _schema.forms?.expectedResult?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.expectedResult?.disabled)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.expectedResult && (
            <SubProjectExpectedResultWidget
              showCommandButton={!schema.forms.expectedResult.disabled}
              schema={schema.forms.expectedResult}
              isEdit={isEditWidget.expectedResult}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('expectedResult', _isEdit, setIsEditWidget)
              }
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
